import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {AffiliatesListRequest, ListAccountsRequest, User} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {FormListener} from "../form/Form";
import {AffiliatesService} from "../../services/AffiliatesService";


interface State extends ListViewState<AffiliatesListRequest> {
    listRequest?: ListAccountsRequest,
    form? : AffiliatesListRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export class AffiliateListView extends ListView<State, AffiliatesListRequest> implements FormListener<AffiliatesListRequest>{

    columns = [
        { property : "id", name : "ID"},
        { property : "email", name : "Email"},
        { property : "enabled", name : "Enabled"},
        { property : "status", name : "Status"},
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "affiliates/user/" + item.id },

    ];

    service : AffiliatesService;

    constructor(props : Props){
        super(props, "/affiliates");
        this.service = getContainer().getAffiliatesService();
        let listRequest =  {  limit: 20, ascending: false, orderBy: "id"}
        this.state = {...this.state,  validationMap : {}, form : {...listRequest}, listRequest : listRequest};
    }
    onSubmit() : void | Promise<any> {

    }
    onSubmitError() :  void {

    }

    formDidUpdate(formModel: AffiliatesListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : User, action : string) : Promise<any> | undefined {
        return;
    }


    pagerChanged(pager : PagerModel) {
        if(!this.state.listRequest){
            return;
        }
        let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
        this.setState({listRequest : listRequest});
    }
    getTitle() {
        return "List Affiliates"
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {/*<div className={"card-box"}>*/}
                {/*    <h4>Search Affiliates</h4>*/}
                {/*    <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>*/}
                {/*        <FormGroup className={"form-group"} model="userId">*/}
                {/*            <label>Affiliate ID</label>*/}
                {/*            <FormInput model={"userId"} className={"form-control"} validators={[Validators.integer()]}/>*/}
                {/*            <span className={"help-text"}>Search for affiliate by ID</span>*/}
                {/*        </FormGroup>*/}
                {/*        <FormGroup className={"form-group"}>*/}
                {/*            <label>Free text</label>*/}
                {/*            <FormInput model={"searchString"} className={"form-control"} validators={[Validators.strLength(3,255)]}/>*/}
                {/*            <span className={"help-text"}>Search for email or user attribute values</span>*/}
                {/*        </FormGroup>*/}
                {/*        <Submit className={"btn btn-primary"}>Search</Submit>*/}
                {/*    </Form>*/}
                {/*</div>*/}
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(AffiliateListView);
